<template>
  <el-popover placement="bottom" width="300" v-model="visible" trigger="manual">
    <div class="f-c config-container">
      <span class="title">Email Configuration</span>
      <el-alert
        v-if="errMsg"
        class="err-msg"
        :closable="false"
        :title="errMsg"
        type="error"
      />
      <el-form ref="form" :model="form">
        <el-form-item>
          <div class="f-c">
            <div class="username">{{ username }}'s email:</div>
            <el-tag size="small">{{ email }} </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="Password: ">
          <el-input
            size="small"
            v-model="form.password"
            clearable
            show-password
          />
        </el-form-item>
      </el-form>
      <div>
        <el-button
          size="small"
          type="primary"
          @click="tryConnect"
          :loading="loading"
        >
          Contect
        </el-button>
        <el-button size="small" plain type="danger" @click="visible = false">
          Cancel
        </el-button>
      </div>
    </div>
    <div slot="reference">
      <div class="email email-normal f-c-c-c">
        <svg-icon
          icon-class="email"
          class="svg-white"
          @click.native="showConfig"
        />
      </div>
    </div>
  </el-popover>
</template>
<script>
import { setEmailPassword, testConnection } from '@/api/mail'
import { mapGetters } from 'vuex'
import { encryptData } from '@/api/encrypt'
export default {
  name: 'EmailConfig',
  data() {
    return {
      visible: false,
      loading: false,
      errMsg: '',
      form: {
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters(['username', 'email'])
  },
  methods: {
    showConfig() {
      this.visible = true
      this.errMsg = ''
    },
    tryConnect() {
      if (!this.form.password) {
        this.errMsg = 'Password is required!'
        return
      }
      this.loading = true
      let encryptedPas
      encryptData(this.form.password)
        .then(async encrypted => {
          encryptedPas = encrypted
          return testConnection(this.username, encrypted)
        })
        .then(res => {
          setEmailPassword(encryptedPas)
          this.errMsg = ''
          this.visible = false
        })
        .catch(e => {
          this.errMsg = e.toString()
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.config-container {
  padding: 5px 10px;

  .title {
    font-size: $title-level-four;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .el-form {
    .el-form-item {
      margin-bottom: 5px !important;
    }
  }

  ::v-deep .el-form-item__label {
    font-size: 13px;
    line-height: 13px;
  }
}

.username {
  line-height: 24px;
}

.email {
  margin-right: 10px;
  width: 28px;
  height: 28px;
  background-color: $business-color;
  border-radius: $radius-buttom-common;

  .svg-icon {
    filter: $svg-white;
    font-size: 21px;
  }

  &:hover {
    cursor: pointer;
  }
}

.err-msg {
  ::v-deep span {
    font-size: 12px;
  }

  padding: 8px;
}
</style>
